import * as CONST from '../ActionTypes';

const initialState = {
  data: {},
  data_products: {},
  data_orders: {},
};

function dashboard(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // DASHBOARDデータ取得
    // -----------------
    case CONST.GET_DATA_DASHBOARD_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          data: action.payload,
        },
      );
    case CONST.GET_DATA_DASHBOARD_FAILURE:
      return Object.assign(
        {},
        state,
        {
          data: {},
        },
      );
    // -----------------
    // DASHBOARD商品データ取得
    // -----------------
    case CONST.GET_DATA_DASHBOARD_PRODUCTS_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          data_products: action.payload,
        },
      );
    case CONST.GET_DATA_DASHBOARD_PRODUCTS_FAILURE:
      return Object.assign(
        {},
        state,
        {
          data_products: {},
        },
      );
    // -----------------
    // DASHBOARDオーダーデータ取得
    // -----------------
    case CONST.GET_DATA_DASHBOARD_ORDER_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          data_orders: action.payload?.data_by_order,
        },
      );
    case CONST.GET_DATA_DASHBOARD_ORDER_FAILURE:
      return Object.assign(
        {},
        state,
        {
          data_orders: {},
        },
      );
    default:
      return state;
  }
}

export default dashboard;
